var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircleGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_circle_FILL0_wght400_GRAD0_opsz48 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facturation-\\u2022-Liste-des-prestations",
    transform: "translate(-1517.000000, -761.000000)",
    fill: "#37DC58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_circle_FILL0_wght400_GRAD0_opsz48",
    transform: "translate(1517.000000, 761.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.525,14.55 L15.6,7.475 L14.45,6.35 L8.525,12.275 L5.525,9.275 L4.4,10.4 L8.525,14.55 Z M10,20 C8.63333333,20 7.34166667,19.7375 6.125,19.2125 C4.90833333,18.6875 3.84583333,17.9708333 2.9375,17.0625 C2.02916667,16.1541667 1.3125,15.0916667 0.7875,13.875 C0.2625,12.6583333 0,11.3666667 0,10 C0,8.61666667 0.2625,7.31666667 0.7875,6.1 C1.3125,4.88333333 2.02916667,3.825 2.9375,2.925 C3.84583333,2.025 4.90833333,1.3125 6.125,0.7875 C7.34166667,0.2625 8.63333333,0 10,0 C11.3833333,0 12.6833333,0.2625 13.9,0.7875 C15.1166667,1.3125 16.175,2.025 17.075,2.925 C17.975,3.825 18.6875,4.88333333 19.2125,6.1 C19.7375,7.31666667 20,8.61666667 20,10 C20,11.3666667 19.7375,12.6583333 19.2125,13.875 C18.6875,15.0916667 17.975,16.1541667 17.075,17.0625 C16.175,17.9708333 15.1166667,18.6875 13.9,19.2125 C12.6833333,19.7375 11.3833333,20 10,20 Z M10,18.5 C12.3666667,18.5 14.375,17.6708333 16.025,16.0125 C17.675,14.3541667 18.5,12.35 18.5,10 C18.5,7.63333333 17.675,5.625 16.025,3.975 C14.375,2.325 12.3666667,1.5 10,1.5 C7.65,1.5 5.64583333,2.325 3.9875,3.975 C2.32916667,5.625 1.5,7.63333333 1.5,10 C1.5,12.35 2.32916667,14.3541667 3.9875,16.0125 C5.64583333,17.6708333 7.65,18.5 10,18.5 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleGreen);
export default __webpack_public_path__ + "static/media/icon_check_circle_green.04cbe15353fef68e5fb2e555a0cbae8b.svg";
export { ForwardRef as ReactComponent };